import React from 'react'
import i18n from './i18n'
import "./assets/sass/style.scss"
import "./assets/sass/SelectorLanguage.scss"
import francais from './assets/img/fr.png'
import anglais from './assets/img/en.png'
import allemand from './assets/img/de.png'

const languages = [
  {
    name: 'Français',
    img: francais,
    lng: 'fr'
  },
  {
    name: 'English',
    img: anglais,
    lng: 'en'
  },
  {
    name: 'Deutsch',
    img: allemand,
    lng: 'de'
  },
]

export default function SelectorLanguage() {
  function clickLanguage(lng) {
    i18n.changeLanguage(lng);
  }

  return (
    <div className='select-language-container'>
      <ul className='list-languages'>
        {languages.map((language) => (
          <li key={language.lng}>
            <button
              type="button"
              className="language-button"
              onClick={() => clickLanguage(language.lng)}
              aria-label={`Changer la langue en ${language.name}`}
            >
              <img src={language.img} alt={`${language.name} flag`} loading="lazy" decoding="async" />
              <span>{language.name}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
